import { NgClass } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogRef } from '@angular/material/dialog';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { HelpDialogData } from './models/help-dialog-data';

@Component({
    selector: 'app-help-dialog',
    templateUrl: './help-dialog.component.html',
    styleUrls: ['./help-dialog.component.scss'],
    imports: [MatDialogActions, NgClass]
})
export class HelpDialogComponent {
    private readonly htmlPath = '/assets/helper/';
    htmlHelpText: string;

    public faHelp = faCircleQuestion;

    constructor(
        public dialogRef: MatDialogRef<HelpDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: HelpDialogData,
        private http: HttpClient
    ) {
        this.getHtml(this.data.page);
    }

    getHtml(component: string) {
        this.http
            .get(`${this.htmlPath}${component}_fr.html`, {
                responseType: 'text',
            })
            .subscribe((res) => {
                this.htmlHelpText = res;
            });
    }

    onClose(): void {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
}
